import React, { ChangeEvent, useCallback, useState } from 'react';
import DynamicArgsWrapper from '../../containers/ArgsWarpper/ArgsWrapper';
import { TextField } from '@mui/material';
import { TArgs } from '../../types/policies-types';
import { enablePoliciesSaveButton } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';
import { updateProfilePolicyArgs } from '../../actions/policies-profile-actions/policy-state-actions';

const NumberField: React.FC<React.PropsWithChildren<TArgs>> = props => {
  const { name, label, value, range, policyId, tooltip } = props;
  const [inputValue, setInputValue] = useState<number>(value as number);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      enablePoliciesSaveButton(true);
      const { value: targetValue } = event.target;
      if (isNaN(parseInt(targetValue))) return;
      setInputValue(parseInt(targetValue));
    },
    [],
  );

  return (
    <DynamicArgsWrapper
      meta={{
        name,
        tooltip,
      }}>
      <TextField
        label={label}
        InputProps={{
          style: {
            paddingRight: 2,
          },
        }}
        onChange={handleChange}
        size='small'
        name={name}
        value={inputValue}
        type='number'
        inputProps={{
          style: {
            minWidth: 180,
          },
          type: 'number',
          min: range?.[0],
          max: range?.[1],
        }}
        onBlur={useCallback(() => {
          updateProfilePolicyArgs({
            id: policyId,
            name,
            value: inputValue,
          });
        }, [inputValue, name, policyId])}
      />
    </DynamicArgsWrapper>
  );
};

export default NumberField;
